module.exports = __webpack_public_path__ + "media/assets/arrow_right-aa59363fd338a6d71f587f108f60443d.svg";